module.exports = __webpack_public_path__ + "static/img/planning.180bc5c5.png";